import { Outlet, useLocation } from 'react-router-dom';
import Content from '../../../components/content';

export function PharmaciesLayout() {
    const location = useLocation();
    const pathname = location.pathname;
    const inFormContext = pathname.includes('edit') || pathname.includes('create');

    return (
        <Content
            headerTitle={pathname.includes('edit') ? 'Edit Pharmacy' : pathname.includes('create') ? 'New Pharmacy' : 'Pharmacies'}
            backNavLink={inFormContext ? '/settings/pharmacies' : '/settings'}>
            {{ content: <Outlet /> }}
        </Content>
    );
}
